<div class="container">
	<div class="admin-columns">
		<div class="admin-column tree">
			<div class="section-title">Manage all assets</div>
			<div class="asset-tree mb-3">
				<a routerLink="fleetwide" routerLinkActive="selected">Fleetwide operations</a>
			</div>
			@if (treenodes === undefined) {
			<div class="loading-status">
				<div class="logo-spin"></div>
				Loading...
			</div>
			}
			@if (treenodes) {
			<div class="asset-tree scrollable">
				@for (org of treenodes; track org) {
				<div class="org-wrapper">
					<div class="org-row expandable" [attr.data-orgid]="org.organization_id">
						<a (click)="ClickExpander($event)" class="expander-icon" [class.expanded]="org.expanded"></a>
						<a [routerLink]="['org', org.organization_id]" draggable="false" class="org-link" (click)="ClickOrg($event)" routerLinkActive="selected"
							[routerLinkActiveOptions]="{ exact: true }">{{org.name}}</a>
					</div>
					@for (fleet of org.fleets; track fleet) {
					<div class="expandable-children">
						<a [routerLink]="['org', org.organization_id, 'fleet', fleet.fleet_id]" draggable="false" (dragenter)="DragHighlight($event, true)"
							(dragleave)="DragHighlight($event, false)" (dragover)="DragOverFleet($event)" (drop)="DropOnFleet($event, org.organization_id, fleet?.fleet_id, fleet?.fleet_name)"
							class="fleet-link" routerLinkActive="selected" [routerLinkActiveOptions]="{ exact: true }">{{fleet.fleet_name}}</a>
						@for (asset of fleet.assets; track asset) {
						<a [routerLink]="getAssetRouterLink(org.organization_id, fleet.fleet_id, asset.asset_id)" draggable="true"
							(dragstart)="StartAssetDrag($event, org.organization_id, asset.asset_id, asset.asset_name)" class="asset-link" routerLinkActive="selected">{{asset.asset_name}}
							({{asset.obcu_serial_number}})</a>
						}
					</div>
					}
				</div>
				}
			</div>
			}
		</div>
		<div class="admin-column main">
			<router-outlet (activate)="updateRouterOutlet($event)"></router-outlet>
		</div>
	</div>
</div>